<template>
  <div class="home-container">
    <!-- 顶部导航栏 -->
    <header class="header">
      <div class="header-left">
        <div class="logo-container">
          <img src="../assets/logo.png" alt="Logo" class="logo">
          <h1 class="system-title">飞鸟中台管理系统</h1>
        </div>
      </div>
      <div class="header-right">
        <span class="user-info">{{ account }}（{{ name }}）
          <span v-if="employeeName">{{ employeeName }}（{{ department }}-{{ job }}）</span>
        </span>

        <el-button type="text" class="header-btn" @click="changePasswordHandler">修改密码</el-button>
        <el-button type="text" class="header-btn" @click="logout">退出</el-button>
      </div>
    </header>

    <!-- 主体内容区 -->
    <div class="main-container">
      <!-- 侧边菜单 -->
      <aside class="sidebar" :class="{'is-collapsed': isCollapsed}">
        <el-menu
          class="el-menu-vertical"
          background-color="#1a2035"
          text-color="#b0bec5"
          active-text-color="#ffffff"
          :collapse="isCollapsed"
          :collapse-transition="false"
          :default-active="activePath"
          :unique-opened="true"
          router
          >
          <el-menu-item @click="toggleSidebar">
            <i class="el-icon-s-fold toggle-sidebar"></i>
            <span slot="title">菜单区</span>
          </el-menu-item>
          <!-- 动态生成菜单 -->
          <template v-for="item in menuList">
            <!-- 包含子菜单的菜单项 -->
            <el-submenu :index="String(item._id)" :key="item._id" v-if="item.children && item.children.length > 0">
              <template slot="title">
                <i :class="item.icon"></i>
                <span>{{ item.name }}</span>
              </template>
              <!-- 子菜单项 -->
              <el-menu-item
                v-for="subItem in item.children"
                :key="subItem._id"
                :index="subItem.path"
                @click="saveNavState(subItem.path)">
                <i :class="subItem.icon"></i>
                <span>{{ subItem.name }}</span>
              </el-menu-item>
            </el-submenu>
            <!-- 不包含子菜单的菜单项 -->
            <el-menu-item
              v-else
              :index="item.path || String(item._id)"
              :key="item._id"
              @click="item.path ? saveNavState(item.path) : null">
              <i :class="item.icon"></i>
              <span slot="title">{{ item.name }}</span>
            </el-menu-item>
          </template>
        </el-menu>
      </aside>

      <!-- 内容区域 -->
      <main class="content">
        <router-view></router-view>
      </main>

    </div>

    <!-- 修改密码对话框 -->
    <el-dialog
      title="修改密码"
      :visible.sync="passwordDialogVisible"
      width="400px"
      :close-on-click-modal="false">
      <el-form ref="passwordForm" :model="passwordForm" :rules="passwordRules" label-width="80px">
        <el-form-item label="原密码" prop="oldPwd">
          <el-input
            v-model="passwordForm.oldPwd"
            type="password"
            placeholder="请输入原密码"
            show-password>
          </el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPwd">
          <el-input
            v-model="passwordForm.newPwd"
            type="password"
            placeholder="请输入新密码"
            show-password>
          </el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPwd">
          <el-input
            v-model="passwordForm.confirmPwd"
            type="password"
            placeholder="请再次输入新密码"
            show-password>
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelPasswordChange">取 消</el-button>
        <el-button type="primary" @click="confirmPasswordChange" :loading="passwordLoading">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import Menu from '../utility/menu'
export default {
  name: 'HomePage',
  data () {
    return {

      activePath: '',
      account: '',
      name: '',
      employeeName: '',
      department: '',
      job: '',

      isCollapsed: false,
      activeButton: null,

      menuList: [],

      // 修改密码相关数据
      passwordDialogVisible: false,
      passwordLoading: false,
      passwordForm: {
        oldPwd: '',
        newPwd: '',
        confirmPwd: ''
      },
      passwordRules: {
        oldPwd: [
          { required: true, message: '请输入原密码', trigger: 'blur' },
          { min: 5, max: 20, message: '密码长度在 5 到 20 个字符', trigger: 'blur' }
        ],
        newPwd: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 5, max: 20, message: '密码长度在 5 到 20 个字符', trigger: 'blur' },
          { validator: this.validateNewPassword, trigger: 'blur' }
        ],
        confirmPwd: [
          { required: true, message: '请再次输入新密码', trigger: 'blur' },
          { validator: this.validateConfirmPassword, trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    this.activePath = window.sessionStorage.getItem('activePath')
    this.account = window.sessionStorage.getItem('account')
    this.name = window.sessionStorage.getItem('name')
    this.employeeName = window.sessionStorage.getItem('employeeName')
    this.department = window.sessionStorage.getItem('department')
    this.job = window.sessionStorage.getItem('job')

    this.getMenuList()
  },
  methods: {
    async getMenuList () {
      const { data: res } = await this.$http.get('login/menus')
      if (res.meta.status !== 200) {
        return this.$message.error(res.meta.msg)
      }

      this.menuList = Menu.castMenu(res.data.list)
      // G13：模块→已授予动作的并集，供各页面用 utility/permissions.hasAction 控显隐；
      // undefined 兜成 null（直通语义），避免存进字符串 "undefined" 让 hasAction 全线误判
      window.sessionStorage.setItem('grantedActions', JSON.stringify(res.data.grantedActions ?? null))
      // 通知已挂载的子页面：权限数据就位，重算显隐（computed 对 sessionStorage 无响应性）
      window.dispatchEvent(new Event('grantedActions:ready'))
    },

    // 切换侧边栏
    toggleSidebar () {
      this.isCollapsed = !this.isCollapsed
    },

    logout () {
      this.$confirm('确认退出系统吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        window.sessionStorage.clear()
        this.$router.push('/login')
        this.$message.success('已安全退出系统')
      }).catch(() => {
        this.$message.info('已取消退出操作')
      })
    },

    changePasswordHandler () {
      this.passwordDialogVisible = true
    },

    // 取消修改密码
    cancelPasswordChange () {
      this.passwordDialogVisible = false
      this.resetPasswordForm()
    },

    // 确认修改密码
    confirmPasswordChange () {
      this.$refs.passwordForm.validate(async (valid) => {
        if (valid) {
          this.passwordLoading = true
          try {
            const { data: res } = await this.$http.post('login/changepassword', {
              oldPwd: this.passwordForm.oldPwd,
              newPwd: this.passwordForm.newPwd
            })
            if (res.meta.status !== 200) {
              this.$message.error(res.meta.msg)
              this.passwordLoading = false
              return
            }
            this.$message.success('密码修改成功，请重新登录')
            // 清除本地存储并跳转到登录页
            window.sessionStorage.clear()
            this.$router.push('/login')
            // 成功时关闭对话框
            this.passwordDialogVisible = false
            this.resetPasswordForm()
          } catch (error) {
            this.$message.error('密码修改失败，请稍后重试')
          } finally {
            this.passwordLoading = false
          }
        }
      })
    },

    // 重置密码表单
    resetPasswordForm () {
      this.passwordForm = {
        oldPwd: '',
        newPwd: '',
        confirmPwd: ''
      }
      this.$nextTick(() => {
        this.$refs.passwordForm && this.$refs.passwordForm.clearValidate()
      })
    },

    // 验证新密码
    validateNewPassword (rule, value, callback) {
      if (value === this.passwordForm.oldPwd) {
        callback(new Error('新密码不能与原密码相同'))
      } else {
        if (this.passwordForm.confirmPwd !== '') {
          this.$refs.passwordForm.validateField('confirmPwd')
        }
        callback()
      }
    },

    // 验证确认密码
    validateConfirmPassword (rule, value, callback) {
      if (value !== this.passwordForm.newPwd) {
        callback(new Error('两次输入密码不一致'))
      } else {
        callback()
      }
    },

    // 保存导航状态
    saveNavState (activePath) {
      window.sessionStorage.setItem('activePath', activePath)
      this.activePath = activePath
    }

  }
}
</script>

<style scoped>
.home-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100%;
}

/* 顶部导航栏样式 */
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 60px;
  padding: 0 20px;
  background: linear-gradient(135deg, #1a2035 0%, #303a52 100%);
  color: #fff;
  border-bottom: none;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
}

.header-left {
  display: flex;
  align-items: center;
}

.logo-container {
  display: flex;
  align-items: center;
}

.toggle-sidebar {
  font-size: 18px;
  cursor: pointer;
  transition: all 0.3s;
}

.toggle-sidebar:hover {
  color: #409EFF;
  transform: scale(1.1);
}

.logo {
  width: 40px;
  height: 40px;
  object-fit: contain;
  border-radius: 4px;
  margin-right: 10px;
  background-color: rgba(255, 255, 255, 0.9);
  padding: 3px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.system-title {
  font-size: 18px;
  font-weight: 500;
  color: #ffffff;
  margin: 0;
  letter-spacing: 0.5px;
}

.header-right {
  display: flex;
  align-items: center;
}

.user-info {
  margin-right: 15px;
  font-size: 14px;
  color: #ffffff;
  display: flex;
  align-items: center;
}

.user-info:before {
  content: "";
  display: inline-block;
  width: 8px;
  height: 8px;
  background-color: #4caf50;
  border-radius: 50%;
  margin-right: 8px;
}

.header-btn {
  font-size: 14px;
  color: #ffffff;
  padding: 7px 12px;
  border-radius: 4px;
  transition: all 0.3s;
}

.header-btn:hover {
  background-color: rgba(255, 255, 255, 0.15);
}

/* 主体内容区样式 */
.main-container {
  display: flex;
  flex: 1;
  overflow: hidden;
}

/* 侧边菜单样式 */
.sidebar {
  width: 180px;
  background: linear-gradient(180deg, #1a2035 0%, #303a52 100%);
  border-right: none;
  overflow-y: auto;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.15);
  transition: width 0.3s;
}

.sidebar.is-collapsed {
  width: 64px;
}

.el-menu-vertical {
  border-right: none;
  height: 100%;
  background-color: transparent !important;
}

.el-menu-vertical:not(.el-menu--collapse) {
  width: 180px;
}

/* 内容区域样式 */
.content {
  flex: 1;
  padding: 20px;
  overflow-y: auto;
  background-color: #f5f7fa;
  position: relative;
}
</style>
